import { useTranslation } from 'react-i18next';
import { LegalShell, LegalLead, LegalH2, LegalP } from './LegalPages';

export function AboutPage() {
  const { t } = useTranslation();
  return (
    <LegalShell titleKey="about.title">
      <LegalLead>{t('about.lead')}</LegalLead>

      <LegalH2>{t('about.why_title')}</LegalH2>
      <LegalP>{t('about.why_body')}</LegalP>

      <LegalH2>{t('about.believe_title')}</LegalH2>
      <div className="mt-4 grid gap-px bg-ink-200 border border-ink-200 md:grid-cols-2">
        {[
          { title: t('about.believe_pricing_title'), body: t('about.believe_pricing_body') },
          { title: t('about.believe_jp_title'), body: t('about.believe_jp_body') },
          { title: t('about.believe_ai_title'), body: t('about.believe_ai_body') },
          { title: t('about.believe_compare_title'), body: t('about.believe_compare_body') },
        ].map((p) => (
          <div key={p.title} className="bg-white p-5">
            <p className="text-sm font-semibold text-ink-900">{p.title}</p>
            <p className="mt-2 text-[13px] text-ink-600 leading-relaxed">{p.body}</p>
          </div>
        ))}
      </div>

      <LegalH2>{t('about.family_title')}</LegalH2>
      <LegalP>{t('about.family_body')}</LegalP>

      <LegalH2>{t('about.where_title')}</LegalH2>
      <LegalP>{t('about.where_body')}</LegalP>
      <p className="mt-3 text-xs uppercase tracking-wide text-ink-500">{t('about.office_address')}</p>
    </LegalShell>
  );
}
